<template>
  <svg>
    <defs>
      <linearGradient
        id="gradient"
        x1="-9.98523"
        y1="7.98818"
        x2="5.60147"
        y2="27.4716"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00FFAA" />
        <stop offset="0.517251" stop-color="#4579F5" />
        <stop offset="0.999815" stop-color="#9C42F5" />
      </linearGradient>
    </defs>
  </svg>
</template>
<script lang="ts">
import { defineComponent } from "vue"
export default defineComponent({})
</script>
<style scoped>
svg {
  height: 0;
  width: 0;
  opacity: 0;
  position: absolute;
  left: 0;
}
</style>
